//hooks
import { useEffect, useState } from "react";
import { NotificationProvider } from "./hooks/context/NotificationContext";
import { UserProvider, UserConsumer } from "./hooks/context/UserContext";

//component
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Notification from "./popup/Notification";
import Loader from "./component/Loader";
import Home from "./page/home/Home";
import About from "./page/about/About";
import Contact from "./page/contact/Contact";
import PrivacyPolicy from "./page/privacyPolicy/PrivacyPolicy";
import Profile from "./page/profile/Profile";
import Client from "./route/Client";

//css file
import "./App.css";

//api
import { GetProfile } from "./api/profile/GetProfile";

//react router dom
import {BrowserRouter, Routes,Route,Navigate, useLocation} from 'react-router-dom';

//mui
import { Container } from "@mui/system";


function AppContent() {
  const [openLoader, setOpenLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setUserData } = UserConsumer();

  useEffect(() => {
    const checkTokenAndFetch = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setOpenLoader(true);
        const result = await GetProfile();
        setUserData(result.data);
        console.log("Get Profile successful:");
      } catch (error: any) {
        console.error("Get Profile failed", error);
      } finally {
        setLoading(false);
        setOpenLoader(false);
      }
    };

    checkTokenAndFetch();
  }, [setUserData]);

  return (
    <>
      {
      loading 
      ? <Loader openLoader={openLoader} setOpenLoader={setOpenLoader} /> 
      : 
      <div className="flex flex-col min-h-[100vh]">
        <Header />
        <main className="flex-1 mt-[100px]">
          <Container maxWidth="xl">
            <Routes>
              <Route path="/" element={<Navigate to="/client" replace />} />
              <Route path="client" element={<Client/>}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="contact" element={<Contact />} />
                <Route path="privacy_policy" element={<PrivacyPolicy />} />
                <Route path="profile" element={<Profile />} />
              </Route>
            </Routes>
          </Container>
        </main>
        <Footer />
        <Notification />
      </div>
      }
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTop/>
        <NotificationProvider>
          <UserProvider>
              <AppContent />
          </UserProvider>
        </NotificationProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;


const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // No UI
};
